export default __webpack_public_path__ + "static/media/instagram.969329e9.png";